import { render } from "./PagePembayaranBiayaKonfirmasi.vue?vue&type=template&id=4b4588b7"
import script from "./PagePembayaranBiayaKonfirmasi.vue?vue&type=script&lang=js"
export * from "./PagePembayaranBiayaKonfirmasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__